import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import { FaInstagram, FaYoutube, FaWhatsapp } from "react-icons/fa6"; // ✅ using FaXTwitter for new X logo

export default function ContactUs() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    setFeedback(null);

    emailjs
      .send(
        "service_kmow15o",
        "template_contactus",
        formData,
        "VNuowFyZMMfK92Rl_"
      )
      .then(() => {
        setFeedback({ type: "success", message: "Message sent successfully!" });
        setFormData({ name: "", email: "", message: "" });
        setSending(false);
      })
      .catch((err) => {
        setFeedback({ type: "error", message: "Failed to send message, please try again." });
        console.error(err);
        setSending(false);
      });
  };

  // ✅ Added X (Twitter) handle
  const socialLinks = {
    instagram: "https://www.instagram.com/dailydoseofdeal/",
    youtube: "https://www.youtube.com/@DailyDoseOfDeal",
    whatsapp: "https://whatsapp.com/channel/0029VbASBHn84Om9sjn2fJ3z"
  };

  return (
    <div className="max-w-xl mx-auto p-6 bg-white rounded-lg shadow-lg mt-12">
      <h2 className="text-3xl font-bold mb-6 text-center text-indigo-700 drop-shadow-md tracking-wide">Contact Us</h2>

      {/* ✅ Social Links */}
      <div className="flex justify-center space-x-8 mb-8 text-4xl">
        <a
          href={socialLinks.instagram}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:scale-110 transition-transform"
          style={{ color: "#E4405F" }}
        >
          <FaInstagram />
        </a>
        <a
          href={socialLinks.youtube}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:scale-110 transition-transform"
          style={{ color: "#FF0000" }}
        >
          <FaYoutube />
        </a>
        <a
          href={socialLinks.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:scale-110 transition-transform"
          style={{ color: "#25D366" }}
        >
          <FaWhatsapp />
        </a>
      </div>

      {/* Contact Form */}
      <form onSubmit={handleSubmit} className="space-y-6">
        <input
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        <input
          name="email"
          placeholder="Your Email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
        />
        <textarea
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          required
          rows={5}
          className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 resize-y"
        />
        <button
          type="submit"
          disabled={sending}
          className={`w-full py-3 rounded-md text-white font-semibold transition ${sending ? "bg-indigo-400 cursor-not-allowed" : "bg-indigo-600 hover:bg-indigo-700"
            }`}
        >
          {sending ? "Sending..." : "Send Message"}
        </button>
      </form>

      {feedback && (
        <p
          className={`mt-6 text-center font-semibold ${feedback.type === "success" ? "text-green-600" : "text-red-600"
            }`}
        >
          {feedback.message}
        </p>
      )}
    </div>
  );
}
